import { constants } from "../../../Constants";
import { connectinDotsVerticalPos } from "../data/matrix-data";
import { getIDs } from "./getID";

const { BLOCK } = constants;


export interface Dict {
    [name: string]: {
        x: number;
        y: number;
        node: boolean
    };
}

/// key orgStageID
export interface IOrgStageCoords extends Dict { }

// key stageID
export interface IConnectionDotsCooords extends Dict { }

export interface IOrgStageCoordsGetterOutput {
    orgStagesCoords: IOrgStageCoords,
    arrayStages: string[],
    arrayOrgNodes: (string | number)[][],
    connectionDotsCoords: { [stageID: string]: { x: number, y: number } }
}

// {
//     orgStagesCoords: OrgStageCoords,
//     arrayStages: string[],
//     arrayOrgNodes: (string | number)[][]
// }


export const getOrgStageCoords = (MATRIX_DATA: (number | string)[][]): IOrgStageCoordsGetterOutput => {

    const arrayStages = MATRIX_DATA[0] as string[]
    const arrayOrgNodes = MATRIX_DATA.slice(1)
    const orgStagesCoords: IOrgStageCoords = {}

    arrayOrgNodes.map((row, i) => {
        // Each row

        row.map((cell, k) => {
            // Each cell
            let stageIndex = i
            let orgIndex = k
            let orgID = row[0];
            let stageID = arrayStages[k];
            let cellValue = cell
            let x = BLOCK.WIDTH * (orgIndex + 0.5)
            let y = BLOCK.HEIGHT * (stageIndex + 0.5)
            let id = `${orgID}-${stageID}`
            let node = false

            if (cellValue === 1 || cellValue === '1') {
                node = true
                // orgStagesCoords[id] = { x, y, node  }
            }

            orgStagesCoords[id] = { x, y, node }
        })
    })






    /**
     * Точки які поєднуть лінії між етапами
     * stageID - координата попереднього (n-1) етапу
     * x - координата поточної організації + половина ширини блоку  
     * y - середнє арифеметичне Y координат етапу 
     */
    let connectionDotsCoords: IConnectionDotsCooords = {}

    
    Object.keys(orgStagesCoords).map(orgStageID => {
        let { orgID, stageID, stageIndex } = getIDs(orgStageID)
        let { x, y } = orgStagesCoords[orgStageID]

        let horizontal = x + BLOCK.WIDTH / 2;


        let vertical = connectinDotsVerticalPos[stageIndex];

        connectionDotsCoords[stageID] = { x: horizontal, y: vertical, node: false }
    })

    console.log('connectionDotsCoords')
    console.log(connectionDotsCoords)
    return {
        arrayStages,
        arrayOrgNodes,
        orgStagesCoords,
        connectionDotsCoords
    }
}